import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./HomeIntroHero.module.css";
import { NewsletterService } from "Logic/NewsletterService";
import { RouteParamsNewsLetter } from "@model/Home.model";

const NewsletterUnsubscribePage: React.FC = () => {
  const { email } = useParams<RouteParamsNewsLetter>();
  const navigate = useNavigate();

  const [apiError, setApiError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState<string | null>(null);

  const newsletterService = new NewsletterService();

  useEffect(() => {
    const handleUnsubscribe = async () => {
      setApiError(null);
      setSuccessMsg(null);

      await newsletterService.handleUnsubscribe({
        email: email,
        setLoading,
        setApiError,
        setSuccessMsg,
      });
    };

    handleUnsubscribe();
  }, [email]);

  return (
    <main
      className={styles.unsubPage}
      data-testid="newsletter-unsubscribe-page"
    >
      <section className={styles.unsubCard}>
        <header className={styles.unsubHeader}>
          <h2 className={styles.unsubTitle}>
            <span className={styles.unsubPrefix}>Unsubscribe</span>
            <span className={styles.unsubTitleMain}>
              Your ChimeraTech Newsletter Subscription
            </span>
          </h2>
        </header>

        <div className={styles.unsubBody}>
          {loading ? (
            <p
              className={styles.unsubHelper}
              data-testid="newsletter-unsubscribe-loading"
            >
              Processing your request...
            </p>
          ) : apiError ? (
            <p
              className={styles.unsubError}
              data-testid="newsletter-unsubscribe-error"
              role="alert"
            >
              {apiError}
            </p>
          ) : successMsg ? (
            <p
              className={styles.unsubSuccess}
              data-testid="newsletter-unsubscribe-success"
              role="status"
            >
              {successMsg}
            </p>
          ) : (
            <p className={styles.unsubHelper}>
              Please wait while we update your newsletter preferences.
            </p>
          )}
        </div>

        <footer className={styles.unsubFooter}>
          <button
            type="button"
            className={styles.unsubPrimaryBtn}
            onClick={() => navigate("/", { replace: true })}
            disabled={loading}
            data-testid="newsletter-unsubscribe-ok"
          >
            OK
          </button>
        </footer>
      </section>
    </main>
  );
};

export default NewsletterUnsubscribePage;
